<div class="section-header">
    <div class="title">
        Projektdaten
    </div>
</div>

<div>
    <bd-labeled-input label="Projektname*" placeholder="Projektname"
                      [ngClass]="{'notify-change' : notifyChange( pUNFEnum.NAME)}"
                      required
                      name="projectName" [(ngModel)]="model.project.projectName"
                      [forceFormValidationVisibility]="forceFormValidationVisibility"
                      #projectNameNgModel="ngModel">
    </bd-labeled-input>
    <bd-input-error-viewer [ngModelRef]="projectNameNgModel">
    </bd-input-error-viewer>

    <app-info-icon-button [model]="{ title: 'Information',
                           messages: [ 'Angebotsabgabe durch Brother wird spätestens benötigt bis ...',
                            '' ,'Bitte wählen Sie einen Tag, der nach dem nächsten Werktag liegt (Heute +1 Werktag).'],
                           dialogHeight: 105}">
    </app-info-icon-button>


    <bd-labeled-date-input label="Angebotsabgabe*"
                           required
                           [forceFormValidationVisibility]="forceFormValidationVisibility"
                           name="quoteClosingDateMerchant"
                           [(ngModel)]="model.project.quoteClosingDate"
                           [datePickerMinDate]="editModalService.getNextWorkingDate()"
                           [datePickerMaxDate]="editModalService.getNext5YearsDate()"
                           [datePickerDaysDisabled]="[6,0]"
                           [bdMinDate]="editModalService.getNextWorkingDate()"
                           [bdMaxDate]="editModalService.getNext5YearsDate()"
                           appWorkingDay
                           #quoteClosingDateMerchantNgModel="ngModel"
                           (ngModelChange)="onQuoteClosingDateChanged()">
    </bd-labeled-date-input>
    <bd-input-error-viewer [ngModelRef]="quoteClosingDateMerchantNgModel">
    </bd-input-error-viewer>


    <bd-labeled-textarea label="Bemerkung" placeholder="Bemerkung eingeben (Max. 1.000 Zeichen)"
                         [ngClass]="{'notify-change' : notifyChange( pUNFEnum.COMMENT)}"
                         [maxlength]="'1000'"
                         rows="5"
                         [forceFormValidationVisibility]="forceFormValidationVisibility"
                         name="comment" [(ngModel)]="model.project.comment"
                         #commentNgModel="ngModel"
                         limitTo="1000">
    </bd-labeled-textarea>
    <bd-input-error-viewer [ngModelRef]="commentNgModel">
    </bd-input-error-viewer>


</div>
